var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAgent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128.002,
    height: 128,
    viewBox: "0 0 128.002 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3df6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb53de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c48fc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#46f1f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb53de"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69314",
    "data-name": "Group 69314",
    transform: "translate(10162.001 17342)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17364",
    "data-name": "Rectangle 17364",
    width: 128,
    height: 128,
    transform: "translate(-10162 -17342)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69313",
    "data-name": "Group 69313",
    transform: "translate(229.25 10.343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69315",
    "data-name": "Group 69315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M4312.666-3760.647v-37.592c16.99,0,24.41.733,24.41,18.8h0c0,18.063-7.42,18.8-24.41,18.8",
    transform: "translate(-14600.324 -13495.851)",
    fill: "#d4d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M1774.366-3760.647v-37.592c-16.989,0-24.41.733-24.41,18.8h0c0,18.063,7.421,18.8,24.41,18.8",
    transform: "translate(-12141.207 -13495.851)",
    fill: "#d4d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "M2868.262-4514.37h37.592c0-16.989-.733-24.41-18.8-24.41h0c-18.063,0-18.8,7.42-18.8,24.41",
    transform: "translate(-13214.309 -12785.244)",
    fill: "#d4d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M2056.672-4399.417c0,36.994-19.146,44.912-56.14,44.912s-56.141-7.918-56.141-44.912,19.147-44.912,56.141-44.912,56.14,7.918,56.14,44.912",
    transform: "translate(-12327.781 -12875.877)",
    fill: "#d4d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M3169.265-5082.729a7.211,7.211,0,0,1-7.212,7.211,7.211,7.211,0,0,1-7.211-7.211,7.211,7.211,0,0,1,7.211-7.211,7.211,7.211,0,0,1,7.212,7.211",
    transform: "translate(-13489.305 -12256.363)",
    fill: "#d4d8de"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M3234.333-4790.877l2.4-17.736h3.195l2.415,17.865-8.011-.129",
    transform: "translate(-13565.582 -12526.317)",
    fill: "#d4d8de"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M2320.383-4048.127c-17.366,0-28.235-1.95-34.2-6.139a16.235,16.235,0,0,1-5.854-7.671c-1.731-4.337-2.61-10.269-2.61-17.629s.878-13.292,2.61-17.629a16.234,16.234,0,0,1,5.854-7.671c5.968-4.188,16.837-6.139,34.2-6.139s28.235,1.95,34.2,6.139a16.237,16.237,0,0,1,5.854,7.671c1.732,4.337,2.61,10.269,2.61,17.629s-.878,13.292-2.61,17.629a16.238,16.238,0,0,1-5.854,7.671c-5.969,4.188-16.837,6.139-34.2,6.139",
    transform: "translate(-12647.634 -13195.729)",
    fill: "#222a41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69316",
    "data-name": "Group 69316",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M2739.536-3539.432c-4.507,0-5.471,4.119-5.471,8.334s.964,8.334,5.471,8.334,5.471-4.119,5.471-8.334-.965-8.334-5.471-8.334",
    transform: "translate(-13085.535 -13744.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M3667.18-3539.432c-4.507,0-5.471,4.119-5.471,8.334s.965,8.334,5.471,8.334,5.471-4.119,5.471-8.334-.965-8.334-5.471-8.334",
    transform: "translate(-13975.682 -13744.196)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_69317",
    "data-name": "Group 69317",
    transform: "translate(-10351.248 -17291.402)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17344",
    "data-name": "Rectangle 17344",
    width: 10.399,
    height: 29.463,
    rx: 5,
    transform: "translate(37.601 1.021)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17345",
    "data-name": "Rectangle 17345",
    width: 10.399,
    height: 31.197,
    rx: 5,
    transform: "translate(15.598 0) rotate(30)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17346",
    "data-name": "Rectangle 17346",
    width: 10.399,
    height: 31.197,
    rx: 5,
    transform: "translate(11.265 5.199) rotate(-30)",
    fill: "url(#linear-gradient-3)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAgent);
export default __webpack_public_path__ + "static/media/ai-agent.9cd9b6070d558cc8e9c0b004aaa33499.svg";
export { ForwardRef as ReactComponent };